import { createFileRoute } from '@tanstack/react-router';

import { getAgreementQueryOptions } from '@/_pages/agreements/api-service';
import Loading from '@/_pages/agreements/subsidies/loading';

export const Route = createFileRoute('/_private/agreements/_template/$id/subsidies')({
  loader: (opts) => opts.context.queryClient.ensureQueryData(getAgreementQueryOptions(opts.params.id)),
  staticData: {
    renderRightColumn: false,
    pageTitle: 'Subsidies',
    tabKey: 'agreement/subsidies',
    isFullWidth: true,
  },
  pendingComponent: Loading,
});
